import { captureError } from '@smg-real-estate/browser-rum';

import { post } from '@/api/fetch';

export async function getGuestToken(): Promise<{ token: string }> {
  try {
    const response: Response = await post(
      `${import.meta.env.VUE_APP_INSERTION_FUNNEL_API_BASE_URL}/guest-token`,
    );
    return response.json();
  } catch (error) {
    captureError(error, { service: 'guests', action: 'get-guest-token' });
    throw error;
  }
}

export interface MergeGuestDraftsResponse {
  mergedCount: number;
  insertionIds: string[];
}

/**
 * Merges DRAFT insertions from the guest user (guestToken) into the authenticated user.
 * Requires both Bearer token (authenticated user) and X-Guest-Token. Call after login/sign-up
 * when redirecting to billing so the user sees their guest drafts.
 */
export async function mergeGuestDrafts(
  userId: string,
  guestToken: string,
): Promise<MergeGuestDraftsResponse> {
  const baseUrl = import.meta.env.VUE_APP_INSERTION_FUNNEL_API_BASE_URL;
  try {
    const response = await post(
      `${baseUrl}/users/${encodeURIComponent(userId)}/merge-guest-drafts`,
      '',
      { 'X-Guest-Token': `${guestToken}` },
    );
    return response.json();
  } catch (error) {
    captureError(error, {
      service: 'insertion-api',
      action: 'merge-guest-drafts',
      userId,
    });
    throw new Error('Could not merge guest drafts', { cause: error });
  }
}
